"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement("path", { d: "M6 12.95L9.72414 17L18 8", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "square", strokeLinejoin: "round" }));
